const actions = {
  START_NEARBY_PARTIES_REQUEST: "START_NEARBY_PARTIES_REQUEST",
  END_NEARBY_PARTIES_REQUEST: "END_NEARBY_PARTIES_REQUEST",
  LOAD_NEARBY_PARTIES: "LOAD_NEARBY_PARTIES",
};

export default actions;
